<template>
  <div class="inner">
    <div class="mt-5" id="productShapeDrawing-parent">
      <div class="card">
        <div
          class="accordion card-header d-flex justify-content-between"
          id="productShapeDrawing-header"
          data-toggle="collapse"
          data-target="#productShapeDrawing"
          :aria-expanded="false"
          aria-controls="productShapeDrawing"
        >
          <h3 class="mb-0">{{ $t('製品形状') }}</h3>
          <div class="accordion-toggle-btn">
            <b-button block id="productShapeDrawing-up">{{ $t('閉じる') }}</b-button>
            <b-button block id="productShapeDrawing-down">{{ $t('開く') }}</b-button>
          </div>
        </div>
        <div
          id="productShapeDrawing"
          class="collapse"
          aria-labelledby="productShapeDrawing-header"
          data-parent="#productShapeDrawing-parent"
        >
          <div class="card-body">
            <table class="table table-bordered">
              <tbody class="tbody">
                <tr>
                  <th class="table-active text-left w-10" colspan="1">{{ $t('製品寸法') }}</th>
                  <td class="w-50" colspan="1">
                    <template v-if="productShape.shapeType === 'round'">
                      {{ $t("丸") }}
                    </template>
                    <template v-else-if="productShape.shapeType === 'corner'">
                      {{ $t("角") }}
                    </template>
                    <template v-else-if="productShape.shapeType === 'plate'">
                      {{ $t("板") }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <th class="table-active text-left w-10" colspan="1">{{ $t('寸法') }}</th>
                  <td colspan="1" class="w-30">
                    <template v-if="productShape.shapeType === 'round'">
                      <span class="mr-3">&Phi;</span>
                    </template>
                    <template v-if="productShape.shapeType === 'plate'">
                      <span class="mr-3">t</span>
                    </template>
                    <div class="form-check form-check-inline shapeValues">
                      <template v-if="productShape.shapeValues">
                        <template v-if="productShape.shapeValues.length">
                          <template v-for="(item,index) in productShape.shapeValues">
                            <span :key="index">
                              {{ item }}
                            </span>
                          </template>
                          <span class="ml-2">mm</span>
                        </template>
                        <template v-else>
                          -
                        </template>
                      </template>
                      <template v-else>
                        -
                      </template>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th class="table-active text-left w-10">{{ $t('寸法備考') }}</th>
                  <td class="text-break w-50" colspan="1">
                    <template v-if="productShape.shapeNote">
                      {{ productShape.shapeNote }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                  <th class="table-active text-left w-10">{{ $t('重量') }}</th>
                  <td class="w-30">
                    <template v-if="!this.isEmpty(productShape.shapeWeight)">
                      {{ productShape.shapeWeight }}&nbsp;{{ $t('kg') }}
                    </template>
                    <template v-else>
                      -
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-3 mb-5">
      <button
        type="button"
        class="btn btn-light create-btn"
        @click="modalOpen(1)"
      >{{ $t('編集') }}</button>
    </div>
    <product-shape-modal
    :oldForm="productShape"
    ref="productShape"
    @registered="registered()"
    @modalClose="modalClose()"
    ></product-shape-modal>
  </div>
</template>

<script>
import productShapeModal from './productShapeModal'
export default {
  props: {
    productShape: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    }
  },
  components: {
    productShapeModal,
  },
  mounted() {
    const up = document.getElementById('productShapeDrawing-up')
    const down = document.getElementById('productShapeDrawing-down')
    up.classList.add('is-hide')
    down.classList.add('is-show')
    $('#productShapeDrawing').on('show.bs.collapse', function() {
      const up = document.getElementById('productShapeDrawing-up')
      const down = document.getElementById('productShapeDrawing-down')
      up.classList.add('is-show')
      up.classList.remove('is-hide')
      down.classList.remove('is-show')
      down.classList.add('is-hide')
    })
    $('#productShapeDrawing').on('hide.bs.collapse', function() {
      const up = document.getElementById('productShapeDrawing-up')
      const down = document.getElementById('productShapeDrawing-down')
      up.classList.remove('is-show')
      up.classList.add('is-hide')
      down.classList.add('is-show')
      down.classList.remove('is-hide')
    })
    $('#productShapeDrawing').collapse('hide')
  },
  methods: {
    modalOpen(id) {
      this.$refs.productShape.modalOpen(id)
    },
    registered() {
      this.$emit('registered')
    },
    modalClose() {
      this.$emit('modalClose')
    },
  },
  watch: {
    'productShape': {
      handler: function(newVal) {
        if (!newVal.shapeType) {
          $('#productShapeDrawing').collapse('hide')
        } else {
          $('#productShapeDrawing').collapse('show')
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.shapeValues > span + span {
  margin-left: 1rem;
}
.shapeValues > span + span::before {
  position: static;
  margin-right: .5rem;
}
</style>
